<template>
  <v-container>
    <ContentHeader
      header-icon="mdi-note-alert-outline"
      header-title="Monitor Alerts"
      back-navigation
      back-navigation-href="/admin"
      back-navigation-text="To Old Admin"
    >
    </ContentHeader>
    <pt-sheet
      title="Monitor Alert Bulk Resolve"
      class="main-content"
      :subtitle="
        validationErrors
          ? 'Correct the following errors and upload the file again'
          : null
      "
    >
      <div v-if="errorRecords">
        <monitor-alert-bulk-resolve-errors
          :records="errorRecords"
          :validation-errors="validationErrors"
          @reset="reset"
        />
      </div>
      <div v-else>
        <template v-if="success">
          <div class="text-center">
            <v-icon style="margin-bottom: 56px">$employeeUploadSuccess</v-icon>
            <p>
              The file has been uploaded.
            </p>
            <yellow-button @click="reset">Reset</yellow-button>
          </div>
        </template>
        <template v-else>
          <div class="d-flex justify-center">
            <file-upload-dnd
              class="flex-grow-1"
              :accepted-files="{
                CSV: 'text/csv'
              }"
              :dropzone-options="dropzoneOptions"
              title="Upload Monitor Alert Bulk Resolve CSV File"
              @input="fileId = $event"
            >
            </file-upload-dnd>
          </div>

          <div class="text-right mt-8">
            <v-btn
              class="mb-4"
              depressed
              color="primary"
              @click="uploadFile()"
              :block="$vuetify.breakpoint.xsOnly"
              :disabled="!fileId"
              :loading="loading"
            >
              Upload File
            </v-btn>
          </div>
        </template>
      </div>
    </pt-sheet>
  </v-container>
</template>

<script>
import FileUploadDnd from "@/components/FileUploadDnd";
import { post } from "@/services/request";
import PtSheet from "@/components/PtSheet.vue";
import hasNotifications from "@/mixins/has-notifications";
import hasCurrentUser from "@/mixins/has-current-user";
import { monitorAlertBulkResolveAPI } from "@/services/api";
import YellowButton from "@/components/providertrust/buttons/SmallYellowButton";
import MonitorAlertBulkResolveErrors from "@/views/admin/MonitorAlertBulkResolveErrors.vue";
import ContentHeader from "@/views/ContentHeader.vue";

const dropzoneOptions = {
  url: "/services/files",
  headers: {
    "user-type": "admin",
    "directory-name": "alert-bulk-resolve"
  }
};

export default {
  name: "MonitorAlertBulkResolve",

  mixins: [hasCurrentUser, hasNotifications],
  components: {
    ContentHeader,
    MonitorAlertBulkResolveErrors,
    PtSheet,
    FileUploadDnd,
    YellowButton
  },

  data() {
    return {
      fileId: null,
      dropzoneOptions,
      success: false,
      errorRecords: null,
      validationErrors: null,
      loading: false
    };
  },
  created() {},
  computed: {},
  methods: {
    reset() {
      this.fileId = null;
      this.success = false;
      this.errorRecords = null;
      this.validationErrors = null;
    },
    uploadFile() {
      this.loading = true;
      const fileId = this.fileId;

      post(monitorAlertBulkResolveAPI, {
        fileId
      }).then(
        () => {
          console.log(
            "Monitor alert bulk resolve file submit successful, fileId: ",
            fileId
          );

          this.reset();
          this.success = true;
          this.loading = false;
        },
        error => {
          console.error(
            "Monitor alert bulk resolve file submit failed, fileId: ",
            fileId
          );

          this.loading = false;

          if (!error.response || error.response.status === 500) {
            this.showMessage({
              mode: "error",
              text: "Unknown error. Please try again later"
            });
            return;
          } else if (error.response.status === 404) {
            this.showMessage({
              mode: "error",
              text:
                "Invalid file. Please upload a file with three columns in this order: Monitor Record ID, Progress " +
                "Status, Note"
            });
            return;
          }

          const response = error.response.data;
          if (response) {
            this.errorRecords = response.data;
            this.validationErrors = response.validationErrors;
          }
        }
      );
    }
  }
};
</script>
